<template>
  <div>
    <div class="row">
      <div class="col s12">
        <v-expansion-panel v-model="isSelected" class="custom-expansion-panel">
          <v-expansion-panel-content v-for="(item, i) in channels" :key="i">
            <template v-slot:actions>
              <v-icon class="expansion-panel-text">$vuetify.icons.expand</v-icon>
            </template>
            <template v-slot:header style="background-color: #000">
              <div class="expansion-panel-text" style="text-transform: uppercase">
                {{ item.title }}
              </div>
            </template>
            <v-card class="pa-3">
              <template v-if="isSelected == i">
                <manage-open-time-bot :channel="item.apptype"></manage-open-time-bot>
              </template>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
    </div>
  </div>
</template>

<script>
import ManageOpenTimeBot from './ManageOpenTimeBot'
export default {
  components: {
    ManageOpenTimeBot
  },
  data() {
    return {
      channels: [
        { apptype: 'facebook', title: 'Facebook' },
        { apptype: 'line', title: 'Line' },
        { apptype: 'webchat', title: 'Web Chat' },
        { apptype: 'app', title: 'App Chat' }
      ],
      isSelected: null
    }
  },
  computed: {},
  methods: {
    onSelect(val) {
      console.log(val)
    }
  }
}
</script>

<style lang="scss">
.custom-expansion-panel {
  .expansion-panel-text {
    color: #ff706b;
  }
  .v-expansion-panel__container--active {
    .v-expansion-panel__header {
      background-color: #ff706b !important;
      -webkit-transition: background-color 500ms linear;
      -ms-transition: background-color 500ms linear;
      transition: background-color 500ms linear;
    }
    .expansion-panel-text {
      color: #fff !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/GpfSettingBot.vue